import "./avantDePoursuivre.scss";
import {
  Button,
  Card,
  Emphasis,
} from "@lya-protect/lya-protect-form-library/dist/UI";
import { LoaderOverlay } from "@src/components/loaderOverlay/LoaderOverlay";
import { NavButton } from "@src/components/navButton/NavButton";
import { Stepbar } from "@src/components/stepbar/Stepbar";
import { MicroStep, StepProps } from "@src/Steps/step/Steps";

export type AvantDePoursuivreData = undefined;
type AvantDePoursuivreProps = StepProps<AvantDePoursuivreData>;

export function AvantDePoursuivre({
  changeStep,
  projetSouscription,
}: AvantDePoursuivreProps) {
  return (
    <>
      <LoaderOverlay isLoading={projetSouscription === undefined} />
      {projetSouscription !== undefined && (
        <div className="avant-de-poursuivre-step">
          <div className="stepper__centered-container ">
            <div className="avant-de-poursuivre-step__main stepper__centered-content step__grid step__grid--padding-bottom">
              <Stepbar activeMicroStep={MicroStep.PersonalInformation} />
              <NavButton
                onClick={() => {
                  changeStep("CONSENT", "backward");
                }}
              >
                Précédent
              </NavButton>
              <h1>
                Merci de préparer les documents suivants, afin de vous permettre
                de <Emphasis>finaliser votre adhésion</Emphasis> au contrat
                Paxivie :
              </h1>
              <div className="step__grid-bloc step__grid-bloc--small-margin-top avant-de-poursuivre-step__card-container">
                <Card>
                  <ul>
                    <li>pièce d’identité en cours de validité</li>
                    <li>RIB</li>
                    <li>justificatif de domicile</li>
                  </ul>
                </Card>
              </div>
              <Button onClick={() => changeStep("NUM_SECU", "forward")}>
                Suivant
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
